export default {
  COLOR_RED: '#ce181e',
  COLOR_BLUE: '#002f67',
  COLOR_WHITE: '#fff',
  COLOR_WHITE_SMOKE: '#f5f5f5',
  COLOR_GREEN: '#18ce29',
};
